<template>
	<div>
		<vue-highlightable-input
			highlight-style="background-color:yellow"
			:highlight-enabled="highlightEnabled"
			:highlight="highlight"
			v-model.trim="inputValue"

			:id="id"
			:name="name"
			:autocomplete="autocomplete"
			:placeholder="placeholder"
			:class="inputClassListLive"
			:readonly="readonlyLive"
			:required="requiredLive"
			:disabled="disabledLive"

			@change="onChangeHandler"
			@input="onInputHandler"
			@focus="onFocusHandler"
			@blur="onBlurHandler"
		/>
	</div>
</template>

<script>
    import {baseInput} from './../mixins/index.js';
    import VueHighlightableInput from "vue-highlightable-input"

    export default {
        name: 'HighlightableInput',
        components: {
            VueHighlightableInput
        },
        props: {
            highlightEnabled: {type: Boolean, required: true, default: true},
            highlight: {type: Array, required: true, default: []},
        },
        mixins: [baseInput]
    };
</script>
